/* eslint-disable react-hooks/exhaustive-deps */

import { Grid, TableRow, TableCell, Paper } from "@material-ui/core";

import {
  DatatablesFooterServerSide,
  Loading,
  TableToolbar,
  SearchInput,
  TableAction,
} from "App/Component/ui";
import { getComparator, stableSort } from "App/Component/ui/datatable/utils";
import {
  DEFAULT_SHOW_BUTTON_SUBMIT,
  DISABLED_BUTTON_SUBMIT,
  DEFAULT_BOX_SHADOW,
} from "App/constants";
import { useDatatables, useDatatablesServerSide } from "App/hooks";
import {
  defaultToastSuccess,
  defaultToastError,
  isNull,
} from "App/utils/helpers";
import React, { useEffect, useState } from "react";
import { TableItemTransfer } from "./TabBarang";
import { getDataTab } from ".";

import {
  ITEM_TYPE_JASA,
  RESET_TAB_MODAL,
} from "pages/Penjualan/Master/Rikjang/constants";
import {
  deleteItemById,
  addItemById,
} from "pages/Penjualan/Master/Rikjang/api";
import { RikjangFormItem } from "pages/Penjualan/Master/Rikjang/form/RikjangFormItem";
import { FreezeTable } from "components/organism";

function TabJasa({ formData, setFormData, paketID }) {
  const [formJasa, setFormJasa] = useState(RESET_TAB_MODAL);
  const [showModal, setShowModal] = useState(false);
  const [disabled, setDisabled] = useState(DEFAULT_SHOW_BUTTON_SUBMIT);

  const handleClickSelect = async (row) => {
    setFormJasa({
      id: "",
      item_type: ITEM_TYPE_JASA,
      item_id: row.id,
      name: row.nama,
      qty: 1,
    });
    setShowModal(!showModal);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisabled(DISABLED_BUTTON_SUBMIT);
    try {
      const jasa = formData.jasa;
      const checkJasa = jasa.filter((e) => e.item_id === formJasa.item_id);
      if (checkJasa.length === 0) {
        if (formData.isUpdate) {
          const res = await addItemById(
            {
              paket_id: paketID,
              item_type: ITEM_TYPE_JASA,
              item_id: formJasa.item_id,
              qty: formJasa.qty,
            },
            "paket"
          );
          if (res.state) {
            defaultToastSuccess(res.message);

            jasa.push({
              id: res.data.id,
              paket_id: paketID,
              item_type: ITEM_TYPE_JASA,
              item_id: formJasa.item_id,
              qty: formJasa.qty,
              namaJasa: formJasa.name,
            });

            setFormData({
              ...formData,
              jasa,
            });
          } else {
            defaultToastError(res.message);
          }
          setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
          setShowModal(false);
        } else {
          jasa.push({
            item_type: ITEM_TYPE_JASA,
            item_id: formJasa.item_id,
            namaJasa: formJasa.name,
            qty: formJasa.qty,
          });

          setFormData({
            ...formData,
            jasa,
          });
        }
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
        setShowModal(false);
      } else {
        defaultToastError("Jasa sudah ada");
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
        setShowModal(false);
      }
    } catch (error) {}
  };

  const clickDelete = async (row) => {
    const jasa = formData.jasa;
    const checkJasa = jasa.filter((e) => e.item_id !== row.item_id);
    setFormData({
      ...formData,
      jasa: checkJasa,
    });

    if (formData.isUpdate) {
      const res = await deleteItemById(row.id, "paket");
      if (res.state) {
        defaultToastSuccess(res.message);
      } else {
        defaultToastError(res.message);
      }
    }
  };

  return (
    <div>
      {showModal && (
        <RikjangFormItem
          setShowModal={() => setShowModal(false)}
          form={formJasa}
          setForm={setFormJasa}
          disabled={disabled}
          handleSubmit={handleSubmit}
        />
      )}
      <Grid container spacing={2}>
        <Grid item sm={6}>
          <TableJasa handleClickSelect={handleClickSelect} />
        </Grid>

        <Grid item sm={6}>
          <TableItemTransfer
            rows={formData.jasa}
            clickDelete={clickDelete}
            filter='namaJasa'
          />
        </Grid>
      </Grid>
    </div>
  );
}

const RESET_STATE_FORM_FILTER = {
  nama: "",
  pages: 1,
  limit: 10,
};

export const TableJasa = ({
  handleClickSelect,
  title = "Daftar Jasa",
  url = "/master/jasa/ms_jasa/listMsJasa",
  maxHeight = "500px",
}) => {
  const [rows, setRows] = useState([]);
  const [totalData, setTotalData] = useState(0);
  const [loading, setLoading] = useState(false);
  const [formFilter, setFormFilter] = useState(RESET_STATE_FORM_FILTER);

  const setNewData = async (
    pages = formFilter.pages,
    limit = formFilter.limit,
    formSearch = formFilter
  ) => {
    setLoading(true);
    const res = await getDataTab(formSearch, pages, limit, url);
    if (res.state) {
      setRows(res.data);
      setTotalData(res.meta.count);
      setLoading(false);
    } else {
      setRows([]);
      setLoading(false);
      defaultToastError(res.message);
    }
  };

  const handleChange = (text) => async (e) => {
    setFormFilter({
      ...formFilter,
      [text]: e.target.value,
    });

    if (!isNull(e.target.value) && e.target.value.length > 2) {
      await setNewData(formFilter.pages, formFilter.limit, {
        nama: e.target.value,
      });
    } else {
      await setNewData(formFilter.pages, formFilter.limit, {
        nama: "",
      });
    }
  };

  const { order, orderBy, handleRequestSort, length } = useDatatables({
    rows: rows,
    orderByDefault: "nama",
    orderByRow: ["nama"],
  });

  const {
    pagination,
    onNext,
    onPrevious,
    handleClickPageNumber,
    handleChangeLimit,
  } = useDatatablesServerSide({ setNewData: setNewData });

  useEffect(() => {
    setNewData();
  }, []);

  return (
    <>
      <Loading show={loading} />
      <Paper
        sx={{
          boxShadow: DEFAULT_BOX_SHADOW,
        }}>
        <TableToolbar title={title}>
          <SearchInput withIcon={true} onchange={handleChange("nama")} />
        </TableToolbar>

        <FreezeTable
          headCells={headCells}
          handleRequestSort={handleRequestSort}
          order={order}
          maxHeight={maxHeight}
          length={length}
          orderBy={orderBy}>
          {stableSort(rows, getComparator(order, orderBy)).map((row, index) => {
            return (
              <TableRow hover key={index}>
                <TableCell width={"10px"}>{index + 1}</TableCell>

                <TableCell width={"10px"}>
                  <TableAction
                    isUpdate={false}
                    isDelete={false}
                    isSelect={true}
                    clickSelect={() => handleClickSelect(row)}
                  />
                </TableCell>
                <TableCell align='left' width={"20px"}>
                  {row?.id}
                </TableCell>
                <TableCell align='left'>{row?.nama}</TableCell>
              </TableRow>
            );
          })}
        </FreezeTable>
        <div
          style={{
            marginTop: "-0.5rem",
            padding: "0 1rem 1rem 1rem",
          }}>
          <DatatablesFooterServerSide
            totalData={totalData}
            pagination={pagination}
            handleChangeLimit={handleChangeLimit}
            onPrevious={onPrevious}
            onNext={onNext}
            currentPage={pagination.page}
            handleClickPageNumber={handleClickPageNumber}
          />
        </div>
      </Paper>
    </>
  );
};

export { TableJasa as TableJasaInMasterPaket };

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "left",
  },
  {
    id: "id",
    disablePadding: false,
    label: "ID",
    align: "left",
  },
  {
    id: "nama",
    disablePadding: false,
    label: "NAMA",
    align: "left",
    minWidth: "150px",
  },
];

export default TabJasa;
